var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"strategy-page"}},[_c('LandingBanner'),_c('ExtraInfo'),_c('DirectFinance'),_c('FirstStrategy'),_c('SecondStrategy'),_c('ThirdStrategy'),_c('FourthStrategy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }